import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/vw/en/translations.json';
import en_IE from './locales/vw/en-IE/translations.json';
import en_GB from './locales/vw/en-GB/translations.json';
import de_DE from './locales/vw/de-DE/translations.json';
import de_CH from './locales/vw/de-CH/translations.json';
import de_AT from './locales/vw/de-AT/translations.json';
import es_ES from './locales/vw/es-ES/translations.json';
import fr_FR from './locales/vw/fr-FR/translations.json';
import fr_CH from './locales/vw/fr-CH/translations.json';
import it_IT from './locales/vw/it-IT/translations.json';
import it_CH from './locales/vw/it-CH/translations.json';
import pl_PL from './locales/vw/pl-PL/translations.json';
import sv_SE from './locales/vw/sv-SE/translations.json';
import no_NO from './locales/vw/no-NO/translations.json';
import nl_NL from './locales/vw/nl-NL/translations.json';
import fr_LU from './locales/vw/fr-LU/translations.json';
import en_NZ from './locales/vw/en-NZ/translations.json';
import en_ZA from './locales/vw/en-ZA/translations.json';
import { Locale } from '@org-avp/avp-hck-dga-customerui-commons';

export const resources = {
  en: {
    translation: en,
  },
  'en-IE': {
    translation: en_IE,
  },
  'en-GB': {
    translation: en_GB,
  },
  'de-CH': {
    translation: de_CH,
  },
  'de-DE': {
    translation: de_DE,
  },
  'de-AT': {
    translation: de_AT,
  },
  'es-ES': {
    translation: es_ES,
  },
  'fr-FR': {
    translation: fr_FR,
  },
  'fr-CH': {
    translation: fr_CH,
  },
  'it-IT': {
    translation: it_IT,
  },
  'it-CH': {
    translation: it_CH,
  },
  'pl-PL': {
    translation: pl_PL,
  },
  'sv-SE': {
    translation: sv_SE,
  },
  'no-NO': {
    translation: no_NO,
  },
  'nl-NL': {
    translation: nl_NL,
  },
  'fr-LU': {
    translation: fr_LU,
  },
  'en-NZ': {
    translation: en_NZ,
  },
  'en-ZA': {
    translation: en_ZA,
  },
};

export const toInitialLanguage = (locale: string): Locale => {
  if (locale in resources) {
    return locale as Locale;
  }
  const baseLang = locale.slice(0, 2);

  const initialLanguage = Object.keys(resources).find((key) => key.startsWith(baseLang));
  return initialLanguage ? (initialLanguage as Locale) : Locale.en;
};

export const initI18n = (lng: string): void => {
  void use(initReactI18next).init({
    lng: lng || 'en',
    debug: true,
    fallbackLng: 'en',
    resources,
  });
};
